<script>
  import { fade } from "svelte/transition";

  export let organizeProductMaster;
  export let productMap;

  /**
   * 整理された商品情報を表示用に再整理
   * @param productmaster {object}
   * @return newProductMaster {Array}
   *  [0] => name(パス3)
   *  [1] => info
   */
  const reorganizeProductMaster = (productmaster) => {
    const newProductMaster = Object.entries(productmaster).reverse();
    return newProductMaster;
  };

  //現在の年月日を出力
  const correctNumberTwoDigit = (number = 1) => {
    if (number.toString().length === 1) {
      const newNumber = "0" + String(number);
      return newNumber;
    } else {
      return number;
    }
  };

  const dateIns = new Date();
  const dateObj = {
    year: dateIns.getFullYear(),
    month: correctNumberTwoDigit(dateIns.getMonth() + 1),
    day: correctNumberTwoDigit(dateIns.getDate()),
  };
  const currentDate = `${dateObj.year}-${dateObj.month}-${dateObj.day}`;

  /**
   * 価格強調表示
   * @param data {Array}
   */
  const checkExaggarationState = (data = []) => {
    if (data["PRICE_CHANGE_EXAGGRATION_DATE"]["value"]) {
      //日付の比較（データ内の日付が今日より後の場合、商品を強調表示）
      const settingDate = data["PRICE_CHANGE_EXAGGRATION_DATE"]["value"];
      if (settingDate >= currentDate) {
        return "true";
      }
    }
    return "false";
  };

  /**
   * 該当ファイルが無い場合の判定
   */
  const hasStock = (map) =>{
    if(map.size){
      // const cardTotalNumber = map.
      let cardTotalNumber = 0;
      let _values = map.values();
      for(let val of _values){
        cardTotalNumber += val.length;
      }
      if(cardTotalNumber > 0){
        return true;
      }
    }
  }
</script>

{#await organizeProductMaster() then response}
  {#if hasStock(productMap)}
    {#each [...productMap] as [key, value], index}
      {#if value.length > 0}
      <h2 id={`scrollTarget${index}`}><span>{key}</span></h2>
      <ul>
        {#each value as data}
          <li>
            <div class="image">
              {#if data.IMAGE_PATH.value}
                <img src={data.IMAGE_PATH.value} alt={data.PRODUCT_NAME.value} loading="lazy" width="150" height="153" />
              {:else}
                <img src={"/images/dummy.png"} alt={data.PRODUCT_NAME.value} loading="lazy" width="150" height="153" />
              {/if}
            </div>
            <p class="price" data-exa={checkExaggarationState(data)}>
              ¥{Number(data.PURCHASE_PRICE.value).toLocaleString()}
            </p>
            <div class="title">
              <p class="code">{data.ORGIN_CODE.value}</p>
              <h3>{data.PRODUCT_NAME.value}</h3>
            </div>
            <p class="exaggarate" data-exa={checkExaggarationState(data)}>価格変更しました</p>
            <p class="note">{data.MEMO.value}</p>
          </li>
        {/each}
      </ul>
      {/if}
    {/each}
  {:else}
    <p class="not-available">申し訳ございません、ご指定の条件に該当する商品はございませんでした。</p>
  {/if}

{/await}

<style>
  .price[data-exa="true"] {
    background-color: #ff7500 !important;
    color: #fff !important;
    font-size: 1.6rem !important;
    line-height: 0.9 !important;
    position: relative !important;
    padding-top: 0.8rem !important;
    padding-bottom: 0.7rem !important;
  }
  .exaggarate[data-exa="true"] {
    color: #ff7500;
    font-size: 0.625rem;
    margin-top: 4px;
  }
  .exaggarate[data-exa="false"] {
    display: none;
  }
  .not-available{
    font-size: 16px;
    text-align: center;
    padding: 100px 0;
    border: 1px solid #ccc;
    max-width: calc(100% - 40px);
    margin-left: auto;
    margin-right: auto;
    border-radius: 4px;
  }
  @media screen and (max-width: 768px) {
    .exaggarate[data-exa="true"] {
      font-size: 1.2rem;
    }
    .not-available{
      padding: 40px 20px;
      font-size: 14px;
      line-height: 1.8;
    }
  }
</style>
